import api from "./client";
import { attributionPayload } from "../utils/attribution";

/* ── Public: fetch Atelier collection products ── */

export async function fetchAtelierProducts() {
  const { data } = await api.get("/api/atelier/products");
  return data.data;
}

/* ── Public: fetch Atelier piece prices keyed by type (CORSET/PANTS/SET) ── */

export async function fetchAtelierPrices() {
  const { data } = await api.get("/api/atelier/prices");
  return data.data;
}

/* ── Public: submit Atelier order ── */

export async function submitAtelierOrder(orderData) {
  const { data } = await api.post("/api/atelier/order", {
    ...orderData,
    attribution: attributionPayload(),
  });
  return data.data;
}

/* ── Public: track Atelier order ── */

export async function trackAtelierOrder(orderNumber) {
  const { data } = await api.get(`/api/atelier/track/${orderNumber}`);
  return data.data;
}

/* ── Public: get measurement history by email ── */

export async function getMeasurementHistory(email) {
  const { data } = await api.get(`/api/atelier/measurements/${encodeURIComponent(email)}`);
  return data.data;
}

/* ── Admin: list Atelier orders ── */

export async function getAtelierOrders(filters = {}) {
  const params = new URLSearchParams();
  if (filters.status && filters.status !== "All") params.append("status", filters.status);
  if (filters.productType && filters.productType !== "All") params.append("productType", filters.productType);
  if (filters.search) params.append("search", filters.search);
  params.append("page", filters.page || 1);
  params.append("limit", filters.limit || 10);
  const { data } = await api.get(`/api/admin/atelier-orders?${params}`);
  return { orders: data.data, total: data.total, page: data.page, limit: data.limit };
}

/* ── Admin: Atelier order counts ── */

export async function getAtelierOrderCounts() {
  const { data } = await api.get('/api/admin/atelier-orders/counts');
  return data.data;
}

/* ── Admin: update Atelier order status ── */

export async function updateAtelierOrderStatus(id, status) {
  const { data } = await api.put(`/api/admin/atelier-orders/${id}/status`, { status });
  return data.data;
}

export async function updateAtelierPaymentStatus(id, paymentStatus) {
  const { data } = await api.put(`/api/admin/atelier-orders/${id}/payment-status`, { paymentStatus });
  return data.data;
}
